<template>
<v-row>
</v-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({

  }),
  methods: {
    ...mapActions(['setToken', 'setUser']),
    logout(){
      localStorage.removeItem('token')
      this.setToken({token: null, isRemember: true});
      this.setUser = {};
      this.$router.push("/");
      location.reload();
    }
  },
  mounted() {
    this.logout();
  },
};
</script>


<style scoped>
</style>


// WEBPACK FOOTER //
// logout.vue?bcbe458e